import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { rollUpAnimation } from '@libraries/design-system';
import { phoneMask, phoneNumberValidator } from '@libraries/ui';
import { select, Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { i18nImprovements } from '../../helpers';
import {
  CloseActive,
  getComingSoonPrefill,
  isRightOutletLoading,
  SubmitIneligibleProperty,
} from '../../state';

@Component({
  selector: 'coming-soon',
  templateUrl: './coming-soon.component.html',
  styleUrls: ['./coming-soon.component.scss'],
  animations: [rollUpAnimation('easeOut', '6rem', '0.32s ease-out', '0.32s ease-out')],
  standalone: false,
})
export class ComingSoonComponent implements OnInit {
  public comingSoonForm: UntypedFormGroup;
  public note: UntypedFormGroup;
  public propertyType: UntypedFormGroup;
  public improvements: UntypedFormGroup;
  public phoneFormat = phoneMask;
  // User Selection Options
  public items = i18nImprovements;
  public isLoading$ = this.store.pipe(select(isRightOutletLoading));
  public showOtherDetails = false;

  constructor(private fb: UntypedFormBuilder, private store: Store) {
    this.buildForm();
    this.prefillForm();
  }

  // LifeCycle Hooks //

  ngOnInit() {}

  // Functions //

  onCancel() {
    this.store.dispatch(CloseActive());
  }

  onSubmit() {
    this.comingSoonForm.markAllAsTouched();
    if (this.comingSoonForm.valid)
      this.store.dispatch(SubmitIneligibleProperty({ payload: this.comingSoonForm.value }));
  }

  // Form Builder //

  prefillForm() {
    this.store.pipe(select(getComingSoonPrefill), take(1)).subscribe((prefillData) => {
      this.comingSoonForm.setValue({ ...prefillData });
    });
  }

  private buildForm() {
    // Notes Section
    this.note = this.fb.group({
      name: [null, Validators.compose([Validators.required, Validators.minLength(2)])],
      phone: [
        null,
        Validators.compose([Validators.required, Validators.minLength(2), phoneNumberValidator]),
      ],
      address: [{ value: null, disabled: true }, Validators.required],
      message: [null, null],
    });

    this.comingSoonForm = this.fb.group({
      note: this.note,
      propertyType: [null, Validators.required],
      otherDetails: [null, null],
      improvements: [[]],
    });
  }
}
